import AddBoxIcon from "@mui/icons-material/AddBox";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import EditIcon from "@mui/icons-material/Edit";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import SearchIcon from "@mui/icons-material/Search";
import ErrorIcon from "@mui/icons-material/ErrorOutline";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Tooltip,
} from "@mui/material";
import { isAxiosError } from "axios";
import React, { Fragment, useMemo, useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  ACCOUNT_CONFIGS,
  CHECK_ID_URL,
  INIT_PERSONAL_INFO,
  initialSelectedPhoneCountry,
} from "../../../assets/data/common";
import QuestionIcon16pxSvg from "../../../assets/images/icons/QuestionIcon16pxSvg";
import {
  addNewUser,
  addUser,
  editUser,
  getInfoByCitizen,
  updateUser,
} from "../../../axios/User/UserApi";
import CustomInput from "../../../components/CustomInput";
import CustomSelect from "../../../components/CustomSelect";
import DefaultTooltip from "../../../components/DefaultTooltip";
import {
  ControlpanelPrimaryButton,
  ControlpanelSecondaryButton,
  GrayIconButton,
} from "../../../components/StyledButton";
import { CustomDialog } from "../../../components/StyledComponents";
import { useLoading } from "../../../context/LoadingContext";
import {
  useConnectWS,
  useGetDeviceDetails,
  useReadCard,
} from "../../../hooks/useCheckid";
import {
  generateRandomString,
  generateRandomString4Key,
} from "../../../utils/Function/commonFunction";
import { EmailRegex } from "../../../utils/regex/Regex";
import SelectUserGroupsDialog from "./SelectUserGroupsDialog";
import avatar_2 from "../../../assets/images/logo/avatar-default-logo.png";
import { useAuth } from "../../../context/AuthContext";
import { infoGetByPPersonalID } from "../../../axios/Account/AccountApi";
import { getListEntitieById } from "../../../axios/Setting/SettingUrlApi";
import { parse, format } from "date-fns";
import { listUserAdmin } from "../../../axios/Notification/NotificationApi";
import CustomDateTimePicker from "../../../components/CustomDateTimeRangePicker";
import AddIcon from '@mui/icons-material/Add';
import { getDesignationOptions } from "../../../assets/data/designationOptions";
import CustomSelectRosterSelectUser from "../../../components/CustomSelectRosterSelectUser";
import CustomSelectRosterSelectGroup from "../../../components/CustomSelectRosterSelectGroup";
import { getListDesignation } from "../../../axios/Designation/DesignationApi";

const initValue = {
  userId: null,
  employeeCode: "",
  firstName: "",
  lastName: "",
  personalID: "",
  email: "",
  telephone: null,
  address: "",
  city: null,
  country: "VNM",
  state: null,
  zipCode: null,
  profilePicture: "",
  barCode: null,
  groupCodes: null,
  administratorRights: "EMPLOYEE",
  designationId: null,
  registrationToken: null,
  createdTime: "",
  modifiedTime: "",
  status: true,
  active: "",
  owner: true,
  companyId: null,
  accountId: null,
  rfid: null,
  userTypeId: 1,
  fullName: "",
  department: "",
  placeOfBirth: "",
  joinDate: null,
};

const CustomHelpIcon = ({ size = 20, color = "#BDBDBD" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_4237_12059)">
      <path
        d="M20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10ZM6.87 7.54125H7.90125C8.07375 7.54125 8.21125 7.4 8.23375 7.22875C8.34625 6.40875 8.90875 5.81125 9.91125 5.81125C10.7688 5.81125 11.5538 6.24 11.5538 7.27125C11.5538 8.065 11.0863 8.43 10.3475 8.985C9.50625 9.59625 8.84 10.31 8.8875 11.4688L8.89125 11.74C8.89256 11.822 8.92606 11.9002 8.98453 11.9577C9.04299 12.0153 9.12173 12.0475 9.20375 12.0475H10.2175C10.3004 12.0475 10.3799 12.0146 10.4385 11.956C10.4971 11.8974 10.53 11.8179 10.53 11.735V11.6038C10.53 10.7063 10.8713 10.445 11.7925 9.74625C12.5538 9.1675 13.3475 8.525 13.3475 7.17625C13.3475 5.2875 11.7525 4.375 10.0063 4.375C8.4225 4.375 6.6875 5.1125 6.56875 7.2325C6.56704 7.27287 6.5736 7.31316 6.58804 7.3509C6.60248 7.38863 6.62448 7.42302 6.65269 7.45194C6.68091 7.48085 6.71474 7.5037 6.75211 7.51906C6.78949 7.53442 6.8296 7.54197 6.87 7.54125ZM9.77625 15.595C10.5387 15.595 11.0625 15.1025 11.0625 14.4362C11.0625 13.7463 10.5375 13.2613 9.77625 13.2613C9.04625 13.2613 8.515 13.7463 8.515 14.4362C8.515 15.1025 9.04625 15.595 9.7775 15.595H9.77625Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_4237_12059">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// const getDepartmentPrefixFromEmployeeCode = (employeeCode, departmentList) => {
//   const prefix = employeeCode.substring(0, 2).toUpperCase();
//   const matchedDepartment = departmentList.find(
//     (dep) => dep.departmentPrefix.toUpperCase() === prefix
//   );
//   return matchedDepartment
//     ? matchedDepartment.departmentPrefix
//     : departmentList[0].departmentPrefix;
//   //  return matchedDepartment
//   //  ? matchedDepartment.departmentPrefix
//   //  : '';
// };

const getDepartmentPrefixFromEmployeeCode = (employeeCode, departmentList = []) => {
  const code = (employeeCode ?? "").toString();

  // nếu thiếu code hoặc thiếu danh sách phòng ban → trả về phần tử đầu (nếu có) hoặc ""
  if (code.length < 2 || !Array.isArray(departmentList) || departmentList.length === 0) {
    return departmentList?.[0]?.departmentPrefix ?? "";
  }

  const prefix = code.slice(0, 2).toUpperCase();
  const matchedDepartment = departmentList.find(
    (dep) => (dep?.departmentPrefix ?? "").toUpperCase() === prefix
  );
  return matchedDepartment?.departmentPrefix ?? departmentList[0]?.departmentPrefix ?? "";
};

const DATE_FIELDS = ["issuanceDate", "expiryDate", "birthDate"];

const AddNewEmployeeDialogForm = ({
  isEdit = false,
  defaultValue = initValue,
  countries,
  userRoles,
  handleRefreshTable,
  onClose,
  handleOpenInvite,
  department,
  groupData,
  groupByUser,
  designation
}) => {
  const { t } = useTranslation();
  const [show, hide] = useLoading();
  const connectWS = useConnectWS();
  const readCard = useReadCard();
  const language = useSelector((state) => state.languageR.language);
  const [personalInfo, setPersonalInfo] = useState(INIT_PERSONAL_INFO);
  const [selectedPhoneCountry, setSelectedPhoneCountry] = useState(
    initialSelectedPhoneCountry
  );
  const [isMissingSoftware, setIsMissingSoftware] = useState(false);
  const [readingCard, setReadingCard] = useState(false);

  const [open, setOpen] = useState(false);
  const getDevice = useGetDeviceDetails();
  const { departmentSatus, dataConfig, genaralSettingDateFormat, profile } =
    useAuth();
  const [statusEmail, setStatusEmail] = useState(false);
  const [statusCity, setStatusCity] = useState(false);
  const [statusAddress, setStatusAddress] = useState(false);

  const [formData, setFormData] = useState(() => {
    let initialGroupCodes = [];

    if (isEdit && Array.isArray(groupByUser)) {
      initialGroupCodes = groupByUser
        .map(item => {
          if (typeof item === 'object' && item !== null) {
            return item.id || item.groupCode || item.value || '';
          }
          return String(item).trim();
        })
        .filter(Boolean);
    }

    // === AUTO SELECT GROUP ID = 1 (All users) ===
    const group1Exists = initialGroupCodes.some(id => String(id) === "1");
    if (!group1Exists) {
      initialGroupCodes = [1, ...initialGroupCodes];   // dùng số 1 để khớp với groupData
    }

    const today = new Date();

    return {
      profilePicture: defaultValue.profilePicture ?? "",
      firstName: defaultValue.firstName ?? "",
      lastName: defaultValue.lastName ?? "",
      employeeCode: defaultValue.employeeCode ?? "",
      email: defaultValue.email ?? "",
      personalID: defaultValue.personalID ?? "",
      administratorRights: defaultValue.administratorRights ?? "EMPLOYEE",
      address: defaultValue.permanentAddress ?? defaultValue.address ?? "",
      city: defaultValue.city ?? "",
      country: defaultValue.country ?? "VNM",
      state: defaultValue.state ?? "",
      zipCode: defaultValue.zipCode ?? "",
      telephone: defaultValue.telephone ?? "",

      groupCodes: initialGroupCodes,        // ← Bắt buộc có id = 1

      designationId: defaultValue.designationId
        ? Number(defaultValue.designationId)
        : "",
      // status: defaultValue.status ?? true,
      userTypeId: defaultValue.userTypeId === 0 ? 1 : (defaultValue.userTypeId ?? 1),
      fullName: defaultValue.fullName ?? "",

      department: isEdit
        ? getDepartmentPrefixFromEmployeeCode(defaultValue.employeeCode, department)
        : departmentSatus
          ? department?.[0]?.departmentPrefix ?? ""
          : "",

      langId: localStorage.getItem("i18nextLngId"),
      permanentAddress: defaultValue.permanentAddress ?? "",

      joinedDate: isEdit
        ? (defaultValue.joinDate
          ? new Date(defaultValue.joinDate)   // chuyển về Date object
          : null)
        : today,
    };
  });

  const [validationMessages, setValidationMessages] = useState({
    email: "",
    employeeCode: "",
    telephone: "",
    personalID: "",
    userTypeId: "",
  });
  const [openSelectUserGroups, setopenSelectUserGroups] = useState(false);
  const [avatar, setAvatar] = useState("");
  // const invalid = useMemo(
  //   () =>
  //     Object.values(validationMessages).some((v) => !!v) ||
  //     !formData.email ||
  //     !formData.employeeCode ||
  //     !formData.personalID ||
  //     !formData.fullName || [validationMessages, formData] // !formData.firstName,
  // );
  const invalid = useMemo(
    () =>
      Object.values(validationMessages).some(Boolean) ||
      !formData.email ||
      !formData.employeeCode ||
      !formData.personalID ||
      !formData.fullName,
    [validationMessages, formData]
  );
  const skipBlurRef = useRef(false);
  const [onBlurEvent, setonBlurEvent] = useState(false);

  const fileInputRef = useRef(null);
  const [imageBase64, setImageBase64] = useState(
    formData.profilePicture
      ? `data:image/png;base64,${formData.profilePicture}`
      : ""
  );

  const [isReadCard, setIsReadCard] = useState(false);
  const [dataReadcard, setDataReadcard] = useState(null);
  const [dataInfo, setDataInfo] = useState({
    profilePicture: null,
  });
  const designationOptions = getDesignationOptions(t);

  const WATCH_KEYS = [
    "profilePicture",
    "firstName",
    "lastName",
    "employeeCode",
    "email",
    "personalID",
    "administratorRights",
    "address",
    "city",
    "country",
    "state",
    "zipCode",
    "telephone",
    "groupCodes",
    "designationId",
    "status",
    "userTypeId",
    "fullName",
    "permanentAddress",
  ];

  const normalizeValue = (v) => {
    if (v === undefined || v === null) return null;
    if (typeof v === "string") {
      const s = v.trim();
      return s === "" ? null : s;
    }
    return v;
  };

  const toComparable = (obj) => {
    const o = {};
    for (const k of WATCH_KEYS) {
      if (k === "groupCodes") {
        o[k] = Array.isArray(obj?.[k]) ? obj[k] : [];
      } else {
        o[k] = normalizeValue(obj?.[k]);
      }
    }
    return o;
  };

  const [originalData] = useState(() => toComparable(defaultValue));
  const [hasChanged, setHasChanged] = useState(false);

  useEffect(() => {
    const current = toComparable(formData);
    const base = originalData;

    const sameImage =
      (base.profilePicture
        ? `data:image/png;base64,${base.profilePicture}`
        : "") === (imageBase64 || "");

    setHasChanged(
      JSON.stringify(current) !== JSON.stringify(base) || !sameImage
    );
  }, [formData, imageBase64, originalData]);

  const userType = [
    { value: 1, label: t("common.full-time") },
    { value: 2, label: t("common.part-time") },
  ];

  const updateFormDataWithGroups = (selectedGroups) => {
    updateFormDataAndValidate("groupCodes", selectedGroups);
  };

  const setListUserAdmin = async () => {
    try {
      const response = await listUserAdmin(profile.companyId);
      console(response);
    } catch (error) {
      console.log(error);
    }
  };

  const browserProfilePicture = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageBase64(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDataChange = (name, newData) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: newData,
    }));
  };

  const resetProfilePicture = () => {
    setImageBase64(`data:image/png;base64,${formData.profilePicture}`);
  };

  const updateFormDataAndValidate = (name, value) => {
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    switch (name) {
      case "employeeCode":
        setValidationMessages((prevMessages) => ({
          ...prevMessages,
          firstName: value
            ? value > 6
              ? "common.content-084"
              : ""
            : "common.content-083",
        }));
        break;

      case "email":
        setValidationMessages((prevMessages) => ({
          ...prevMessages,
          email: value
            ? EmailRegex.test(value)
              ? ""
              : "validation.email-invalid-format"
            : "validation.email-required",
        }));
        break;

      case "personalID":
        setFormData((prevData) => ({
          ...prevData,
          firstName: "",
          lastName: "",
          profilePicture: "",
          city: "",
          address: "",
          email: "",
          fullName: "",
        }));
        setStatusEmail(false);
        setStatusCity(false);
        setStatusAddress(false);
        setValidationMessages((prevMessages) => ({
          ...prevMessages,
          personalID: value
            ? value.length <= 12
              ? ""
              : "common.content-009"
            : "common.content-008",
        }));
        break;

      case "telephone":
        setValidationMessages((prevMessages) => ({
          ...prevMessages,
          telephone: value
            ? selectedPhoneCountry.phoneRegex.test(value)
              ? ""
              : "common.content-024"
            : "",
        }));
        break;
      case "userTypeId":
        setValidationMessages((prevMessages) => ({
          ...prevMessages,
          userTypeId: value ? "" : value,
        }));
        break;
      case "department":
        setValidationMessages((prevMessages) => ({
          ...prevMessages,
          department: value ? "" : value,
        }));
        break;

      case "zipCode":
        setValidationMessages((prevMessages) => ({
          ...prevMessages,
          zipCode: value
            ? /^[A-Za-z0-9\s-]{3,10}$/.test(value)
              ? "" // Hợp lệ
              : "validation.invalid-zip" // Không hợp lệ
            : "", // Cho phép để trống
        }));
        break;
      default:
        break;
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "groupCodes") {
      let newGroups = Array.isArray(value) ? value : [];

      // Bảo vệ group ID 1 không bị xóa
      if (!newGroups.some(id => String(id) === "1")) {
        newGroups = [1, ...newGroups];
      }

      setFormData(prev => ({
        ...prev,
        groupCodes: newGroups
      }));
      return;
    }

    // Đổi phòng ban → tự tạo mã nhân viên mới theo prefix phòng ban
    if (name === "department") {
      const nextEmployeeCode =
        departmentSatus && value && value !== "NO"
          ? generateRandomString4Key(value)
          : generateRandomString();

      updateFormDataAndValidate("department", value);
      updateFormDataAndValidate("employeeCode", nextEmployeeCode);
      return;
    }

    // Các trường khác
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));

    updateFormDataAndValidate(name, value);
  };

  const handleOpenSelectUserGroups = () => {
    setopenSelectUserGroups(true);
  };

  const handleCloseSelectUserGroups = () => {
    setopenSelectUserGroups(false);
  };

  const handleGenerateRandom = () => {
    if (departmentSatus) {
      if (formData.department !== "NO") {
        updateFormDataAndValidate(
          "employeeCode",
          generateRandomString4Key(formData.department)
        );
      } else {
        updateFormDataAndValidate("employeeCode", generateRandomString());
        // updateFormDataAndValidate("employeeCode", 'ABC123');
      }
    } else {
      updateFormDataAndValidate("employeeCode", generateRandomString());
      // updateFormDataAndValidate("employeeCode", 'ABC123');
    }
  };

  const handleCloseDialog = () => {
    if (readingCard) return;
    onClose();
  };

  const handleSubmit = async (e) => {
    const base64Data = imageBase64 ? imageBase64.split(",")[1] : null;

    let joinedDateStr = formData.joinedDate;
    if (joinedDateStr instanceof Date) {
      joinedDateStr = joinedDateStr.toISOString().split('T')[0];
    } else if (typeof joinedDateStr === "string" && joinedDateStr.length > 10) {
      // Nếu bị truyền vào dạng đầy đủ (Wed Apr 08...)
      joinedDateStr = new Date(joinedDateStr).toISOString().split('T')[0];
    }

    let processedGroupCodes = [];

    if (Array.isArray(formData.groupCodes)) {
      processedGroupCodes = formData.groupCodes
        .filter((group) => group != null)
        .map((group) => {
          // Trường hợp group là object
          if (typeof group === "object" && group !== null) {
            return group.groupCode || group.id || group.value || group;
          }
          // Trường hợp group đã là string
          return group;
        })
        .filter(Boolean); // loại bỏ giá trị rỗng/falsy
    }

    try {
      e.preventDefault();
      show();
      setReadingCard(true);
      const payload = {
        ...formData,
        profilePicture: base64Data,
        groupIds: processedGroupCodes,
        designationId: formData.designationId || null,   // ← truyền designation
        joinDate: joinedDateStr,
        fullName: personalInfo.fullName,
        // dateOfBirth: format(formData.dateOfBirth, "yyyy-MM-dd"),
        // permanentAddress: formData.permanentAddress
      };

      if (isEdit) {
        payload.userId = defaultValue.userId;
        payload.langId = localStorage.getItem("i18nextLngId")
        const response = await updateUser(payload);
        setHasChanged(false);

        if (response.data.code === 200) {
          const code = response.data.data.responseCode;
          if (code === 0) {
            toast.success(t("common.content-148"));
            setHasChanged(false);
            Object.assign(originalData, toComparable(formData));
            handleRefreshTable();
            setListUserAdmin();
            onClose();
          } else {
            toast.error(response.data.message);
          }
        } else if (response.data.code) {
          toast.error(response.data.data.message);
          onClose();
        } else {
          toast.error(response.data.data.message);
        }
      } else {
        const finalAvatar = isReadCard
          ? dataReadcard?.image
          : personalInfo?.image;
        payload.profilePicture = finalAvatar;
        payload.dateOfBirth = personalInfo.birthDate;
        payload.gender = personalInfo.gender;
        payload.ethencity = personalInfo.ethnic;
        payload.issueDate = personalInfo.issuanceDate;
        // payload.issueDate = '2026-09-24';
        payload.expirationDate = personalInfo.expiryDate;
        payload.placeOfOrigin = personalInfo.placeOfOrigin;
        payload.langId = localStorage.getItem("i18nextLngId")
        payload.employeeCode = department?.length > 0 ? formData.employeeCode : formData.employeeCode
        console.log("payload: ", payload);
        const response = await addNewUser(payload);

        if (response.data.code === 200) {
          const code = response?.data?.data?.responseCode;
          if (code === undefined || code === 0) {
            toast.success(t("common.content-085"));
            setListUserAdmin();
            handleRefreshTable();
            onClose();
          } else {
            toast.error(response.data.data.message);
          }
        } else if (response.data.data.code === 500) {
          toast.error(response.data.message);
          // handleCloseDialog();
        } else {
          toast.error(response.data.data.message);
        }
      }
    } catch (error) {
      console.log("error: ", error);
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data));
        }
      } else {
        toast.error(t('common.network-timeout'));
      }
    } finally {
      hide();
      setReadingCard(false);
    }
  };

  const handleReadCard = (cardId) => {
    if (readingCard) return;
    try {
      show();
      setReadingCard(true);
      let deviceName = false;

      connectWS.mutate(
        {},
        {
          onSuccess: (data) => {
            setIsMissingSoftware(false);
            hide(); // ẩn loading của connectWS
            show(); // bật lại loading cho getDevice + readCard

            getDevice.mutate(
              { lang: language },
              {
                onSuccess: (dataReadcard) => {
                  if (dataReadcard.deviceSN === "54822502250122") {
                    deviceName = true;
                  }
                },
                onError: (error) => {
                  hide();
                  setReadingCard(false); 
                },
              }
            );

            readCard.mutate(
              {
                lang: language,
                code: cardId.slice(-6),
                deviceName: deviceName,
              },
              {
                onSuccess: (dataReadcard) => {
                  hide();
                  setReadingCard(false);
                  handleReadCardSuccess(dataReadcard);

                  if (
                    dataReadcard.optionalDetails.personalNumber !==
                    formData.personalID
                  ) {
                    return setValidationMessages((prev) => ({
                      ...prev,
                      personalID: "common.content-014",
                    }));
                  }

                  if (dataReadcard.optionalDetails) {
                    const { fullName, birthDate, gender, ethnic, issuanceDate, expiryDate, placeOfOrigin, placeOfResidence } =
                      dataReadcard.optionalDetails;

                    const fullNameSplit = fullName.split(" ");
                    const lastName = fullNameSplit.slice(0, -1).join(" ");
                    const firstName = fullNameSplit.at(-1);

                    updateFormDataAndValidate("firstName", firstName);
                    updateFormDataAndValidate("lastName", lastName);
                    setAvatar(dataReadcard.image);

                    setPersonalInfo({
                      ...dataReadcard.optionalDetails,
                      image: dataReadcard.image,
                      birthDate: birthDate
                        ? format(parse(birthDate, "dd/MM/yyyy", new Date()), "yyyy-MM-dd")
                        : "",
                      gender,
                      ethnic,
                      issuanceDate: issuanceDate
                        ? format(parse(issuanceDate, "dd/MM/yyyy", new Date()), "yyyy-MM-dd")
                        : "",
                      expiryDate: expiryDate
                        ? expiryDate === "Không thời hạn"
                          ? "Không thời hạn"
                          : format(parse(expiryDate, "dd/MM/yyyy", new Date()), "yyyy-MM-dd")
                        : "",
                    });

                    const parts = placeOfOrigin.split(",").map((p) => p.trim());
                    const province = parts.pop();

                    setFormData((prev) => ({
                      ...prev,
                      city: province,
                      address: placeOfResidence,
                    }));

                    toast.success(t("common.content-013"));
                  }
                },
                onError: (error) => {
                  hide(); // **luôn dừng loading**
                  setReadingCard(false);
                  if (error.error === 1102) {
                    toast.error(t("common.CAN"));
                  } else {
                    toast.error(error.message || t("common.content-029"));
                  }
                },
              }
            );
          },
          onError: (error) => {
            hide(); // **luôn dừng loading**
            setReadingCard(false);
            setIsMissingSoftware(true);
            toast.error(t("common.content-028"));
          },
        }
      );
    } catch (error) {
      hide(); // **luôn dừng loading**
      setReadingCard(false);
      toast.error(t("common.content-029"));
    }
  };

  const handleReadCardSuccess = (data) => {
    setDataReadcard(data);
    setIsReadCard(true);

    // preview ngay
    setAvatar(data.image);
  };


  const handleClose = () => {
    setOpen(false);
  };

  function dg2ToImage(base64, cutLength = 84) {
    const binaryStr = atob(base64);
    const len = binaryStr.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryStr.charCodeAt(i);
    }
    const trimmedBytes = bytes.slice(cutLength);
    let binaryBase64 = "";
    for (let i = 0; i < trimmedBytes.length; i++) {
      binaryBase64 += String.fromCharCode(trimmedBytes[i]);
    }

    return btoa(binaryBase64);
  }

  const handleGetInfoByPersonalID = (data) => {
    setDataInfo((prev) => ({
      ...prev,
      ...data,
      profilePicture: data.profilePicture,
    }));

    if (!isReadCard) {
      setAvatar(data.profilePicture);
    }
  };


  const fetchInfoUser = async (request) => {
    show();
    try {
      const data = await infoGetByPPersonalID(request);

      if (data.data.data.responseCode === 0) {
        const dataInfo = data.data.data.data[0];
        handleGetInfoByPersonalID(dataInfo);

        setPersonalInfo({
          ...dataInfo,
          fullName: dataInfo.fullName,
          placeOfOrigin: dataInfo.placeOfBirth,
          placeOfResidence: dataInfo.permanentAddress,
          // birthDate: dataInfo.birth_date,
          // expiryDate: dataInfo.expiry_date,
          // issuanceDate: dataInfo.issuance_date,
          personalNumber: dataInfo.citizenIdentificationNumber,
          image: dataInfo.profilePicture,
          birthDate: dataInfo.dateOfBirth,
          gender: dataInfo.gender,
          ethnic: dataInfo.ethnicity,
          issuanceDate: dataInfo.issueDate,
          expiryDate: dataInfo.expirationDate,
          nationality: dataInfo.countryName,
        });
        setFormData((prevData) => ({
          ...prevData,
          email: dataInfo.email,
          city: dataInfo.city,
          address: dataInfo.permanentAddress,
        }));

        setAvatar(dataInfo.profilePicture);

        setStatusEmail(dataInfo.email ? true : false);
        setStatusCity(dataInfo.city ? true : false);
        setStatusAddress(dataInfo.permanentAddress ? true : false);
      } else {
        const response = await getInfoByCitizen(request);
        if (response.data.status === 0) {
          const dataInfoIdtt = response.data.personal_informations;
          const newBase64 = dg2ToImage(dataInfoIdtt.dg2_value, 84);
          setPersonalInfo({
            ...dataInfoIdtt,
            fullName: dataInfoIdtt.full_name,
            placeOfOrigin: dataInfoIdtt.place_of_origin,
            personalNumber: dataInfoIdtt.personal_number,
            image: newBase64,
            birthDate: dataInfoIdtt.birth_date
              ? format(
                parse(dataInfoIdtt.birth_date, "dd/MM/yyyy", new Date()),
                "yyyy-MM-dd"
              )
              : "",
            gender: dataInfoIdtt.gender,
            ethnic: dataInfoIdtt.ethnic,
            issuanceDate: dataInfoIdtt.issuance_date
              ? format(
                parse(dataInfoIdtt.issuance_date, "dd/MM/yyyy", new Date()),
                "yyyy-MM-dd"
              )
              : "",
            expiryDate: dataInfoIdtt.expiry_date
              ? format(
                parse(dataInfoIdtt.expiry_date, "dd/MM/yyyy", new Date()),
                "yyyy-MM-dd"
              )
              : "",
          });
          setAvatar(personalInfo.image);
          const fullAddress = dataInfoIdtt.place_of_origin;
          const parts = fullAddress.split(",").map((part) => part.trim());

          const province = parts.pop();
          setFormData((prev) => ({
            ...prev,
            city: province,
            address: dataInfoIdtt.place_of_origin,
          }));
          setStatusCity(province ? true : false);
          setStatusAddress(fullAddress ? true : false);
          // setStatusEmail(dataInfoIdtt.email ? true : false)
        } else {
          if (response.data.status === 4028) {
            toast.error(t("common.citizenid-card-not-exists"));
          } else {
            toast.error(
              response.data.message.charAt(0).toUpperCase() +
              response.data.message.slice(1).toLowerCase()
            );
          }
        }
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data));
        }
      } else {
        toast.error(t('common.network-timeout'));
      }
    } finally {
      hide();
    }
  };

  const handleBlur = async () => {
    if (skipBlurRef.current || isEdit) {
      skipBlurRef.current = false;
      return;
    }
    if (formData.personalID.trim().length === 12) {
      setonBlurEvent(true);
      fetchInfoUser(formData);
    } else {
      setValidationMessages((prevMessages) => ({
        ...prevMessages,
        personalID: "common.content-009",
      }));
    }
  };

  const handleGetInfoamtionUser = async () => {
    if (formData.personalID.trim().length === 12) {
      fetchInfoUser(formData);
    } else {
      setValidationMessages((prevMessages) => ({
        ...prevMessages,
        personalID: "common.content-009",
      }));
    }
  };

  const handleCallGenarate = () => {
    if (readingCard) return;
    handleGenerateRandom();
    setonBlurEvent(true);
    if (!personalInfo.fullName) {
      handleGetInfoamtionUser();
    }
    if (formData.personalID.length === 0) {
      setValidationMessages((prevMessages) => ({
        ...prevMessages,
        personalID: "",
      }));
    }
  };

  const handleRemoveGroup = (removedGroupId) => {
    if (String(removedGroupId) === "1") {

      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      groupCodes: prevData.groupCodes.filter(id => String(id) !== String(removedGroupId)),
    }));
  };

  return (
    <Fragment>
      <CustomDialog
        maxWidth={"xl"}
        open
        onClose={handleCloseDialog}
        loading={readingCard}
        keepMounted
        // Tắt animation khi đang tour để Reactour đo vị trí đúng ngay
        transitionDuration={window.__tourIsOpen ? 0 : undefined}
      >
        <DialogTitle>
          <div className="flex justify-between">
            <div className="flex items-center gap-4">
              <p className="text-xl font-semibold text-[#1A1D1F]">
                {t(
                  isEdit
                    ? "common.update-existing-employee"
                    : "common.add-new-employee"
                )}
              </p>
              <DefaultTooltip
                // readMore={true}
                title={t("tool-tip.add-edit-users")}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("tool-tip.this-view-allows-to-add-a-new-user")}</p>
                  </div>
                }
              >
                <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
              </DefaultTooltip>
            </div>
            <GrayIconButton onClick={handleCloseDialog} disabled={readingCard}>
              <CloseIcon />
            </GrayIconButton>
          </div>
        </DialogTitle>

        <DialogContent
          className={`relative ${readingCard ? "pointer-events-none" : ""}`}
          data-tour={
            isEdit
              ? "user-management-edit-dialog"
              : "user-management-add-user-diaglog"
          }
        >

          {isEdit && (
            <div className="mt-6 flex items-start justify-between">
              <div className="flex flex-col">
                <div className="flex items-center gap-2 leading-none">
                  <span>{t("common.profile-picture")}</span>
                  {/* <CustomHelpIcon /> */}
                </div>

                <div className="mt-6 border border-gray-200 p-[5px] rounded-[4px]">
                  <img
                    src={imageBase64 ? imageBase64 : avatar_2}
                    alt="Profile"
                    className="w-[168px] h-[170px] object-cover rounded-[4px]"
                  />
                </div>
              </div>

              <div className="flex flex-col gap-2">
                <div className="flex gap-2">
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    accept="image/*"
                    onChange={handleFileChange}
                    disabled={readingCard}
                  />
                  <ControlpanelPrimaryButton
                    onClick={browserProfilePicture}
                    disabled={readingCard}
                  >
                    <SearchIcon />
                    {t("common.browser")}
                  </ControlpanelPrimaryButton>

                  <ControlpanelSecondaryButton className="opacity-50 pointer-events-none">
                    <HelpOutlineIcon />
                    {t("button.unidentified-images")}
                  </ControlpanelSecondaryButton>
                </div>

                <span
                  className={`self-end text-right ${!readingCard &&
                    formData.profilePicture &&
                    imageBase64.replace(/^data:image\/\w+;base64,/, "") !==
                    formData.profilePicture
                    ? "text-blue-500 cursor-pointer"
                    : "text-blue-500 cursor-not-allowed"
                    }`}
                  onClick={
                    !readingCard &&
                      formData.profilePicture &&
                      imageBase64.replace(/^data:image\/\w+;base64,/, "") !==
                      formData.profilePicture
                      ? resetProfilePicture
                      : undefined
                  }
                >
                  {t("common.reset-to-default-profile-picture")}
                </span>
              </div>
            </div>
          )}
          {departmentSatus && (
            <div className="space-y-2 pt-6">
              <label className="block">{t("common.departments")}</label>
              <CustomSelect
                name="department"
                value={formData.department}
                onChange={handleInputChange}
                options={department}
                defaultValue={1}
                dataType="department"
              />
            </div>
          )}

          {/* )} */}

          <form className="pt-4 md:grid md:grid-cols-2 gap-x-3 gap-[10px] relative">
            <div>
              <label className="block text-sm">
                {t("common.personal-id")}
                <span className="text-[#EF4444] ml-1">*</span>
              </label>

              <div className="mt-2 relative flex items-center">
                <input
                  readOnly={isEdit}
                  disabled={readingCard}
                  type="number"
                  name="personalID"
                  className={`form-control h-[40px] no-spin-buttons relative z-40 pr-12 ${!!validationMessages.personalID ? "invalid" : ""
                    }`}
                  value={formData.personalID}
                  onBlur={handleBlur}
                  onChange={(e) => {
                    const value = e.target.value;
                    // ✅ Chỉ cho phép tối đa 12 chữ số
                    if (value.length <= 12) {
                      handleInputChange(e);
                      setPersonalInfo((prev) => ({ ...prev, fullName: "" }));
                    }
                  }}
                />
                <ControlpanelPrimaryButton
                  disabled={
                    readingCard ||
                    !!validationMessages.personalID ||
                    !formData.personalID
                  }
                  className={`w-[6.25rem] !absolute inset-y-0 right-0 !rounded-none !rounded-r-md !text-nowrap z-50 ${readingCard ||
                    !!validationMessages.personalID ||
                    !formData.personalID ||
                    formData.personalID.length !== 12
                    ? "opacity-50"
                    : ""
                    }`}
                  onMouseDown={() => (skipBlurRef.current = true)}
                  onClick={() => handleReadCard(formData.personalID)}
                >
                  {readingCard ? (
                    <CircularProgress size={18} color="inherit" />
                  ) : (
                    t("button.read-card")
                  )}
                </ControlpanelPrimaryButton>
              </div>

              {validationMessages.personalID && (
                <p className="text-[14px] text-red-500 mt-1">
                  {t(validationMessages.personalID)}
                </p>
              )}

              {isMissingSoftware && (
                <div className="col-span-full px-3 py-2 bg-[#f8d7da] rounded-lg mt-2">
                  <p className="text-[#EF4444] text-xs">
                    {t("common.content-018")}
                  </p>
                  <Link
                    className="!text-[#EF4444] !text-xs !decoration-[#EF4444]"
                    href={dataConfig.url_download_checkid}
                    target="_blank"
                  >
                    {t("common.content-019")}
                  </Link>
                </div>
              )}

              {personalInfo.fullName && (
                <button
                  type="button"
                  disabled={readingCard}
                  className="w-full flex items-center justify-start gap-2 text-left text-blue-500 font-semibold py-2.5 disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={() => setOpen(true)}
                >
                  <OpenInNewIcon className="!w-4 !h-4" />
                  {t("common.content-128")}
                </button>
              )}
            </div>

            <div>
              <label className="block text-sm">
                {t("common.employee-code")}
              </label>

              <div className="mt-2 relative flex items-center">
                <input
                  name="employeeCode"
                  disabled={readingCard}
                  className={`form-control no-spin-buttons relative h-[40px] z-40 pr-12 ${!!validationMessages.employeeCode ? "invalid" : ""
                    }`}
                  value={formData.employeeCode}
                  onChange={(e) => {
                    const value = e.target.value
                      .toUpperCase()
                      .replace(/[^A-Z0-9]/g, "");
                    if (value.length <= 6) {
                      handleInputChange({
                        target: { name: "employeeCode", value },
                      });
                    }
                  }}
                />
                <ControlpanelPrimaryButton
                  disabled={readingCard}
                  className={`w-[6.25rem] !absolute inset-y-0 right-0 !rounded-none !rounded-r-md !text-nowrap z-50 ${readingCard ? "opacity-50" : ""}`}
                  onClick={handleCallGenarate}
                  onMouseDown={() => (skipBlurRef.current = true)}
                >
                  {t("button.generate")}
                </ControlpanelPrimaryButton>
              </div>
              {validationMessages.employeeCode && (
                <p className="text-[14px] text-red-500 mt-1">
                  {t(validationMessages.employeeCode)}
                </p>
              )}
            </div>

            {personalInfo.fullName && (
              <CustomInput
                readOnly
                required
                title={t("common.full-name")}
                inputType="text"
                name="firstName"
                value={personalInfo.fullName}
                style={{ height: "40px" }}
              />
            )}

            <div className="space-y-2">
              <label className="block">{t("common.user-type")}</label>
              <CustomSelect
                name="userTypeId"
                value={formData.userTypeId}
                onChange={handleInputChange}
                options={userType}
                defaultValue={1}
                dataType="userTypeId"
                style={{ height: "40px" }}
              />
            </div>

            <div className="space-y-2">
              <label className="block">
                {t("common.administrator-rights")}
              </label>
              <CustomSelect
                name="administratorRights"
                value={formData.administratorRights}
                onChange={handleInputChange}
                options={userRoles}
                defaultValue="EMPLOYEE"
                dataType="administratorRights"
                style={{ height: "40px" }}
                className=""
                readOnly={isEdit && defaultValue?.owner === true}
              />
            </div>

            <CustomInput
              required
              // readOnly={isEdit}
              title={t("common.email-address")}
              inputType="text"
              name="email"
              // readOnly={statusEmail || isEdit ? true : false}
              isError={!!validationMessages.email}
              isSuccess={formData.email && !validationMessages.email}
              message={t(validationMessages.email)}
              placeholder="example@gmail.com"
              handleInputChange={handleInputChange}
              value={formData.email}
              style={{ height: "40px" }}
            />

            <div className="space-y-2">
              <Tooltip title={formData.address} placement="bottom" arrow>
                <div>
                  <CustomInput
                    required={false}
                    readOnly={statusAddress ? true : false}
                    title={t("common.address")}
                    inputType="text"
                    name="address"
                    placeholder={t("common.address")}
                    handleInputChange={handleInputChange}
                    value={formData.address}
                    inputProps={{
                      title: formData.address || "",
                    }}
                    style={{ height: "40px" }}
                  />
                </div>
              </Tooltip>
            </div>

            <div className={`${personalInfo.fullName ? "" : ""} space-y-2`}>
              <CustomInput
                required={false}
                readOnly={!!statusCity}
                title={t("common.city")}
                inputType="text"
                name="city"
                placeholder={t("common.city")}
                handleInputChange={handleInputChange}
                value={formData.city}
                style={{ height: "40px" }}
              />
            </div>

            <div className="space-y-2">
              <label className="block">{t("common.country")}</label>
              <CustomSelect
                name="country"
                className="!bg-white"
                value={formData.country}
                options={countries}
                dataType="country"
                onChange={(e) => {
                  const value = e.target.value;
                  const selectedCountryData = countries.find(
                    (country) => country.alpha3Code === value
                  );
                  setSelectedPhoneCountry({
                    ...selectedCountryData,
                    phoneRegex: new RegExp(selectedCountryData.phoneRegex),
                  });
                  updateFormDataAndValidate(
                    "country",
                    selectedCountryData.alpha3Code
                  );
                }}
                style={{ height: "40px" }}
              />
            </div>

            <div className="space-y-2">
              <CustomInput
                required={false}
                title={t("common.state")}
                inputType="text"
                name="state"
                placeholder={t("common.state")}
                handleInputChange={handleInputChange}
                value={formData.state}
                style={{ height: "40px" }}
              /></div>

            <div className="space-y-2">
              <CustomInput
                required={false}
                title={t("common.zip-code")}
                inputType="text"
                name="zipCode"
                placeholder={t("common.content-088")}
                handleInputChange={handleInputChange}
                value={formData.zipCode}
                isError={!!validationMessages.zipCode}
                message={t(validationMessages.zipCode)}
                style={{ height: "40px" }}
              /></div>

            <div className="space-y-2">
              <label className="block">{t("common.joinedDate")}</label>
              <div className="mt-2">
                <CustomDateTimePicker
                  mode="single"
                  value={formData.joinedDate}
                  onChange={(newDate) => handleDataChange("joinedDate", newDate)}
                  disableTime
                  showOnlyDate
                />
              </div>
            </div>


            <div className="space-y-2 col-span-2">
              <label className="block">{t("common.phone")}</label>
              <div className="relative flex items-center h-10">
                <div className="flex items-center jus gap-1 ps-3.5 relative z-10">
                  <img
                    src={selectedPhoneCountry.nationFlag}
                    alt="flag-icon"
                    className="w-6"
                  />
                  <span className="text-black">
                    {selectedPhoneCountry.callingCode}
                  </span>
                </div>
                <input
                  className={`absolute inset-0 -top-[1px] form-control h-10 ${!!validationMessages.phone ? "invalid" : ""
                    } ${formData.phone && !validationMessages.phone ? "success" : ""
                    }`}
                  value=""
                  onChange={() => { }}
                />
                <input
                  type="number"
                  placeholder={selectedPhoneCountry.placeHolder}
                  name="telephone"
                  disabled={readingCard}
                  className="no-spin-buttons relative z-10 ml-2 flex-1 h-10 outline-none px-2 border-none rounded-r-md bg-transparent item-center"
                  onChange={handleInputChange}
                  value={formData.telephone}
                />
                {formData.telephone && !validationMessages.telephone && (
                  <span className="absolute inset-y-[-3px] right-0 px-3 py-3">
                    <DoneIcon fontSize="small" className="text-green-500" />
                  </span>
                )}
                {!!validationMessages.telephone && (
                  <span className="absolute inset-y-[-3px] right-0 px-3 py-3">
                    <ErrorIcon fontSize="small" className="text-red-500" />
                  </span>
                )}
              </div>
              {validationMessages.telephone && (
                <p className="text-sm text-red-500 mt-1">
                  {t(validationMessages.telephone)}
                </p>
              )}
            </div>

            {/* <div className='space-y-2 mt-2'> */}
            <div className="space-y-2 col-span-2 pointer-events-auto">
              <label className="block">{t("common.designation")}</label>
              <CustomSelect
                name="designationId"
                className="w-full"
                value={formData.designationId}
                options={designation}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  setFormData((data) => ({
                    ...data,
                    designationId: Number(selectedValue),
                  }));
                }}
                style={{ height: "40px" }}
                dataType="designationId"
              />
            </div>

            <div className="space-y-2 col-span-2">
              <label className="block">{t("common.user-groups")}</label>
              <CustomSelectRosterSelectGroup
                multiple={true}
                name="groupCodes"
                value={formData.groupCodes}           // array string (groupCode)
                options={groupData}                   // phải là array object { value, label, groupCode, ... }
                dataType="group"
                onChange={handleInputChange}
                onRemoveItem={handleRemoveGroup}

                // Nếu component hỗ trợ:
                valueKey="groupCode"      // hoặc "id" tùy component của bạn
                labelKey="groupName"      // tên hiển thị
              />
            </div>
          </form>
        </DialogContent>

        <DialogActions>
          <div className="flex gap-2 px-4 py-4">
            <ControlpanelSecondaryButton
              className="h-10"
              onClick={handleCloseDialog}
              disabled={readingCard}
            >
              <p>{t("button.close")}</p>
            </ControlpanelSecondaryButton>

            {isEdit ? (
              <ControlpanelPrimaryButton
                className="h-10"
                onClick={handleSubmit}
                disabled={readingCard || !hasChanged || !!validationMessages.zipCode}
              >
                <Fragment>
                  <p>{t("button.update")}</p>
                </Fragment>
              </ControlpanelPrimaryButton>
            ) : (
              <ControlpanelPrimaryButton
                onClick={handleSubmit}
                disabled={readingCard || !formData.email || !personalInfo.fullName}
                className="h-10"
              >
                <Fragment>
                  <p>{t("button.add")}</p>
                </Fragment>
              </ControlpanelPrimaryButton>
            )}
          </div>
        </DialogActions>
      </CustomDialog>

      {openSelectUserGroups && (
        <SelectUserGroupsDialog
          onClose={handleCloseSelectUserGroups}
          onSubmit={updateFormDataWithGroups}
        />
      )}

      <CustomDialog maxWidth={"xl"} open={open} onClose={handleClose} >
        <DialogTitle>
          <div className="flex justify-between">
            <div className="flex items-center gap-4">
              <p className="text-xl font-semibold text-[#1A1D1F]">
                {t("common.content-128")}
              </p>
            </div>
            <GrayIconButton onClick={handleClose}>
              <CloseIcon />
            </GrayIconButton>
          </div>
        </DialogTitle>
        <DialogContent  className="grid grid-cols-1 sm:grid-cols-2 gap-x-3 relative" >
          <div className="col-span-full pt-6">
            <img
              src={
                personalInfo.image
                  ? `data:image/png;base64,${personalInfo.image}`
                  : avatar_2
              }
              alt="avatar"
              className="mx-auto w-44 h-[180px] border border-gray-200 rounded p-[5px] object-cover"
            />
          </div>

          {ACCOUNT_CONFIGS.personalInfo.map(({ key, title, className }) => (
            <CustomInput
              key={key}
              readOnly
              containerClassName={className}
              title={t(title)}
              inputType="text"
              value={
                DATE_FIELDS.includes(key) && personalInfo[key]
                  ? personalInfo[key] === "Không thời hạn"
                    ? personalInfo[key]
                    : format(
                      new Date(personalInfo[key]),
                      genaralSettingDateFormat
                    )
                  : personalInfo[key]
              }
              className="h-10 mb-4"
            />
          ))}
        </DialogContent>

        <DialogActions>
          <div className="flex gap-2 px-4 py-4">
            <ControlpanelSecondaryButton onClick={() => setOpen(false)}>
              <p>{t("button.close")}</p>
            </ControlpanelSecondaryButton>
          </div>
        </DialogActions>
      </CustomDialog>
    </Fragment>
  );
};

export default AddNewEmployeeDialogForm;
